import { AaasPackage } from '@va/aaas/shared/types';
import { PlanIndexes } from '@va/constants';
import { PlanType } from '@va/dashboard/api-client/pricing-plans.api';

export const getAaasRelevantPlans = (plan: AaasPackage | null | undefined, plans: AaasPackage[]): AaasPackage[] => {
  if (!plan) return [];

  const index = plans.findIndex((p) => p.id === plan.id);
  const plansCount = plans.length;

  switch (index) {
    case -1:
      return [];
    case 0:
      return [plans[1], plans[2]];
    case plansCount:
      return [plans[plansCount - 2], plans[plansCount - 1]];
    default:
      return [plans[index - 1], plans[index + 1]];
  }
};

export const getRelevantPlans = (plan: PlanType | null, plans: Record<number, PlanType>) => {
  if (!plan) return [];

  const relevantPlansMap: Record<number, PlanType[]> = {
    [PlanIndexes.ProPlus]: [plans[plan.index - 2], plans[plan.index - 1]],
    [PlanIndexes.Starter]: [plans[plan.index + 1], plans[plan.index + 2]],
  };

  return relevantPlansMap[plan.index] ?? [plans[plan.index - 1], plans[plan.index + 1]];
};
